import toast from 'react-hot-toast';

/**
 * Copy a string to the system clipboard and show a "Copied" toast.
 *
 * Side effect on success: react-hot-toast notification.
 * Returns the same Promise that navigator.clipboard.writeText returns so callers can
 * await or chain if they need to - current usage is fire-and-forget.
 */
export function copyToClipboard(text: string): Promise<void> {
  const p = navigator.clipboard.writeText(text);
  p.then(() => toast.success('Copied')).catch(() => toast.error('Copy failed'));
  return p;
}
